import { MessageTypesE } from 'declarations/enums/messages';
import type { LastMessageI } from 'declarations/interfaces/tickets';

const parseMessagePrefix = (value: string): string => {
  // Backend can prepend sender display name as "<Sender>: <message>".
  // Remove only that leading prefix, not arbitrary ":" segments inside filenames/timestamps.
  const senderPrefixPattern = /^[^:\r\n]{1,80}:\s+/;
  return value.replace(senderPrefixPattern, '');
};

/**
 * Last Comment column / bulk-edit seed — includes screenshot file name when API provides it.
 */
export const getLastMessageDisplayText = (lastMessage: LastMessageI | undefined): string => {
  if (!lastMessage) {
    return '';
  }
  if (lastMessage.typeId === MessageTypesE.ScreenshotUpload) {
    const messageToDisplay = lastMessage.attachmentText || lastMessage.text || '';
    const parsed = parseMessagePrefix(messageToDisplay);
    const attachmentName = lastMessage.attachmentName?.trim();
    if (attachmentName) {
      if (parsed) {
        return `${parsed} (${attachmentName})`;
      }
      return attachmentName;
    }
    return parsed;
  }
  const messageToDisplay = lastMessage.attachmentText
    ? lastMessage.attachmentText
    : lastMessage.text;
  return parseMessagePrefix(messageToDisplay ?? '');
};
